/* eslint-disable react/require-default-props */
import React from 'react';
import './styles.scss';
export default function SingleSuggestionSection({ suggestedClause }) {
    return (React.createElement("div", { className: "suggestion-section" },
        React.createElement("div", { className: "suggestion-section__title" }, "Suggestion"),
        React.createElement("div", { className: "suggestion-section__checkbox-label" },
            "Code: ",
            suggestedClause.code,
            "; Section: ",
            suggestedClause.section),
        React.createElement("div", { className: "suggestion-section__checkbox-description" }, suggestedClause.description)));
}
